import React, { useEffect, useState } from "react";
import { useMain, useMainState } from "modules/app/contexts";
import { database } from "shared/services";
import { useList } from "react-firebase-hooks/database";

function LoadCredentials() {
  const { user } = useMainState();
  const { updateWhatsappStatus, updateCredentials } = useMain();
  const [credentials, setCredentials] = useState([]);
  const reference = database.ref(`companies/${user?.company_id}/credentials`);
  const [snapshots, loading, _error] = useList(reference);

  useEffect(() => {
    if (!loading && snapshots) {
      setCredentials(snapshots.map((data) => data.val()));
    }
  }, [loading, snapshots]);

  useEffect(() => {
    updateCredentials(credentials);

    credentials.forEach((credential) => {
      if (credential.extra_info) {
        const includeValidStatus = [
          "chatsAvailable",
          "connected",
          "inChat",
        ].includes(credential.sub_status);

        updateWhatsappStatus(includeValidStatus);
      }
    });
  }, [credentials]);

  return <></>;
}

export default LoadCredentials;
